<div class="row">
  <div class="col">
    <kt-intro-message [user]="user"></kt-intro-message>
  </div>
</div>

<div *ngIf="(user | async)?.is_staff" class="row">
  <div class="col-8">
    <kt-no-cod-users></kt-no-cod-users>
  </div>
  <div class="col-4">
    <kt-returned-delivered-chart></kt-returned-delivered-chart>
  </div>
</div>
